<template>
  <div class="row">
    <div
      :class="['col-12', 'noPaddLR', selected ? 'currentRoom' : expiring ? 'anotherRooms blinkRed' : isFallback ? 'anotherRooms warningBg' : 'anotherRooms']"
    >
      <!-- {{room.priority}} {{room.priortime}} -->
      <div class="row row-margin-fix">
        <div :class="[smw ? 'col-2' : 'col-3', 'noPaddingsLR', 'badgesRight']">
          <div :class="smw ? 'statusBadgePositionSM' : 'statusBadgePosition'">
            <b-badge
              :variant="room.clientEndpoint == 'sms' || room.clientEndpoint == 'facebook' ? 'primary' : statusOptions[onlineStatus] ? statusOptions[onlineStatus] : 'secondary'"
            >{{room.clientEndpoint == 'sms' || room.clientEndpoint == 'facebook' ? room.clientEndpoint : onlineStatus ? onlineStatus : 'off'}}</b-badge>
          </div>
          <!-- :src="room.avatarURL" -->
          <b-avatar
            :size="smw ? 33 : 44"
            src="https://img2.freepng.ru/20180625/at/kisspng-business-game-avatar-computer-program-google-smart-object-5b315c2b2ad958.6413531715299615151755.jpg"
            :style="smw ? 'margin-top:12px' : ''"
          ></b-avatar>
        </div>

        <div :class="[smw ? 'col-9' : 'col-8', 'paddingL']">
          <div
            class="sesIdText"
          >{{room.userId != '' ? room.user_firstName + ' ' + room.user_lastName : room.userphone ? room.userphone : 'UnIdentified Client'}}</div>
          <p class="previewMess" v-if="msgs && msgs.length > 0">{{msgs[msgs.length - 1].data.text}}</p>
          <p class="previewMess" v-else>no new messages</p>
        </div>
        <div class="col-1 unreadBadgeInList">
          <div
            class="noPaddingsLR badgesRight"
            v-if="msgs && msgs.filter(el => el.route.from == 'client' && el.readMsg === false).length != 0"
          >
            <b-badge variant="danger">{{msgs.filter(el => el.readMsg === false).length}}</b-badge>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatRoom",

  props: {
    roomstatus: Object,
    room: Object,
    msgs: Array,
    selected: Boolean,
    myChat: Boolean,
    windowWidth: Number
  },
  data() {
    return {
      timeout: {},
      checktime: 0,
      statusOptions: {
        online: "success",
        away: "warning",
        facebook: "primary"
      }
    };
  },
  beforeDestroy: function() {
    if (this.myChat && this.room.assign_expire) {
      clearTimeout(this.timeout);
    }
  },
  computed: {
    smw() {
      return this.windowWidth < 1495;
    },
    isFallback() {
      return this.msgs && this.msgs.length > 0
        ? this.msgs.find(
            m =>
              m.readMsg === false &&
              m.service != undefined &&
              m.service != null &&
              m.service.isFallback === true
          )
          ? true
          : false
        : false;
    },
    onlineStatus() {
      return this.roomstatus ? this.roomstatus.client_page : "off";
    },
    expiring() {
      return this.myChat && this.room.assign_expire
        ? this.room.assign_expire - this.checktime < 6 * 60 * 1000
        : false;
    },
    timeExpired() {
      return this.room.assign_expire <= this.checktime;
    }
  },

  watch: {
    selected: function(val) {
      if (val && this.expiring) {
        this.$emit("expiredRoom", {
          roomId: this.room.ssId,
          expired: false
        });
      }
    },
    timeExpired: function(exp) {
      if (exp) {
        this.$emit("expiredRoom", {
          roomId: this.room.ssId,
          expired: true
        });
      }
    }
  },
  created() {},

  mounted() {
    if (this.myChat && this.room.assign_expire) {
      this.SetCheckTime();
    }
  },

  methods: {
    SetCheckTime() {
      if (this.myChat) {
        this.$nextTick(function() {
          this.checktime = Date.parse(new Date());
        });
        let that = this;
        if (this.room.assign_expire - Date.parse(new Date()) > 0) {
          if (
            this.room.assign_expire - Date.parse(new Date()) - 6 * 60 * 1000 >
            0
          ) {
            this.timeout = setTimeout(function() {
              that.SetCheckTime();
            }, this.room.assign_expire -
              Date.parse(new Date()) -
              6 * 60 * 1000); //
          } else {
            setTimeout(function() {
              this.timeout = that.SetCheckTime();
            }, that.room.assign_expire - Date.parse(new Date())); //
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.statusBadgePosition {
  position: absolute;
  padding-left: 15px;
}
.statusBadgePositionSM {
  position: absolute;
  padding-left: 0;
}
.previewMess {
  white-space: nowrap; /* Запрещаем перенос строк */
  overflow: hidden; /* Обрезаем все, что не помещается в область */
  text-overflow: ellipsis; /* Добавляем многоточие */
  margin-bottom: 0px;
  margin-top: 6px;
}
.sesIdText {
  font-weight: bold;
}
.noPaddingsLR {
  padding-left: 0px;
  padding-right: 0px;
  text-align: left;
  display: inline;
}
.noPaddLR {
  padding-left: 0px;
  padding-right: 0px;
}
.currentRoom {
  /* margin: -21px -20px -21px -20px; */
  /* background-color: rgb(66, 135, 245); */
  /* background-color: #496786; */
  background-color: #2b5278;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #f5f5f5;
}

.anotherRooms {
  background-color: rgb(49, 57, 76);
  padding-top: 10px;
  padding-bottom: 10px;

  transition: 0.1s all;
  transition-delay: 0.2s;
}

.anotherRooms:hover {
  /* background-color: rgb(66, 135, 245); */
  background-color: #4967865e;
  /* background-color: #496786; */
  padding-top: 10px;
  padding-bottom: 10px;

  transition-delay: 0s;
}

.highlightClass {
  background-color: rgb(255, 60, 0);
  padding-top: 10px;
  padding-bottom: 10px;

  transition: 0.1s all;
  transition-delay: 0.2s;
}

.highlightClass:hover {
  background-color: rgb(66, 135, 245, 1);
  padding-top: 10px;
  padding-bottom: 10px;

  transition-delay: 0s;
}

.warningBg {
  -webkit-animation: blink3 3s linear infinite;
  animation: blink3 3s linear infinite;
}

.blinkRed {
  -webkit-animation: blink1 3s linear infinite;
  animation: blink1 3s linear infinite;
}
@-webkit-keyframes blink1 {
  0% {
    background-color: rgba(255, 60, 0, 1);
  }
  50% {
    background-color: rgba(255, 60, 0, 0);
  }
  100% {
    background-color: rgba(255, 60, 0, 1);
  }
}
@keyframes blink1 {
  0% {
    background-color: rgba(255, 60, 0, 1);
  }
  50% {
    background-color: rgba(255, 60, 0, 0);
  }
  100% {
    background-color: rgba(255, 60, 0, 1);
  }
}

@keyframes blink3 {
  0% {
    background-color: rgba(255, 174, 0, 0.972);
  }
  50% {
    background-color: rgba(255, 60, 0, 0);
  }
  100% {
    background-color: rgba(255, 174, 0, 0.972);
  }
}
.badgesRight {
  text-align: right;
}

.paddingL {
  padding: 0px 5px 0px 10px;
  text-align: left;
}
.unreadBadgeInList {
  padding: 0;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 18px;
}
.row-margin-fix {
  margin-left: 0;
  margin-right: 0;
}
</style>